export enum RequestState {
    Pending,
    Done,
    Error,
    Init,
}